// extracted by mini-css-extract-plugin
module.exports = {"ChatMessageReadby":"ChatMessageReadby_ChatMessageReadby__2_zBL","ChatMessageReadby--reverse":"ChatMessageReadby_ChatMessageReadby--reverse__9pFWY"};